export default "__VITE_ASSET__DVOY8xG1__"